import * as React from 'react'
import { withNamespaces } from 'react-i18next'
import { UncontrolledTooltip } from 'reactstrap'
import { answeredByAIImage } from '../../constants'

const AIFlagWithTooltip = ({
    t,
    id
}) => {
    return (
        <div className='ai-answered-icon'>
            <img
                src={answeredByAIImage}
                alt={t('Generated by AI')}
                id={`ai-answered-${id}`}
            />
            <UncontrolledTooltip
                target={`ai-answered-${id}`}
            >
                {t('Generated by AI')}
            </UncontrolledTooltip>
        </div>
    )
}

export default withNamespaces()(AIFlagWithTooltip)
